
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event_id]/information",
      function () {
        return require("private-next-pages/[event_id]/information.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event_id]/information"])
      });
    }
  